/*
Copyright 2026 Dexnet / iON.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/*
 * iON (decision 80): "Data saver" of the call settings. With it on, the
 * video of others is received at half the pixel density and the own
 * camera is captured at 360p. LiveKit takes these when a call connects,
 * so the setting applies from the next call.
 */

import { type RoomOptions, VideoPresets } from "livekit-client";

import { Setting } from "../settings/settings";

export const ionDataSaver = new Setting<boolean>("ion-data-saver", false);

export function withDataSaver(
  options: RoomOptions,
  on: boolean = ionDataSaver.getValue(),
): RoomOptions {
  if (!on) return options;
  return {
    ...options,
    adaptiveStream: { pixelDensity: 0.5 },
    videoCaptureDefaults: {
      ...options.videoCaptureDefaults,
      resolution: VideoPresets.h360.resolution,
    },
  };
}
